// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__I61Dg","link":"Footer_link__QDxoG","list":"Footer_list__QWd7d"};